namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class CampaignStatus extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "1", text: "Draft" });
            this.addItem({ id: "2", text: "Process" });
            this.addItem({ id: "3", text: "Done" });
            this.addItem({ id: "4", text: "Cancel" });
        }
    }
}